import { TranslationService } from "./TranslationService";

export class DateService {
  private static monthsKeys = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ];
  public static getMonthName(date: Date): string {
    return TranslationService.getTranslation(this.monthsKeys[date.getMonth()]);
  }
}
